import { serviceRoles } from "config/access";
import { COURSE_LOGS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import CourseLogsPage from "./container/CourseLogsPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: COURSE_LOGS,
    withSidebar: true,
    withAppBar: true,
    component: CourseLogsPage,
  };
}
